import {
  hsaCartWidgetPlacementSchema,
  hsaPdpWidgetPlacementSchema,
} from "@redotech/redo-conversion-settings-common/hsa-settings";
import * as z from "zod";

export const updateHsaSettings = {
  name: "updateHsaSettings" as const,
  input: z.object({
    pdpWidgetPlacement: hsaPdpWidgetPlacementSchema.optional(),
    /** Storefront cart placements for the cart eligibility widget.
     * Empty/absent clears them. */
    cartWidgetPlacements: z.array(hsaCartWidgetPlacementSchema).optional(),
    /** Customer-facing checkout display name. Empty/absent clears it. */
    paymentMethodName: z.string().optional(),
    /** Absent (stale client) keeps the stored value. */
    showOnlyHsaPaymentMethod: z.boolean().optional(),
  }),
  output: z.null(),
};
